import clsx from "clsx";
import PropTypes from "prop-types";
import React from "react";

export function AccordionSingleItem({ id, title, children, isActive, onShow }) {
	return (
		<div className={clsx("accordion-item", { expanded: isActive })}>
			<button
				type="button"
				className="btn accordion-toggle"
				id={id}
				aria-controls={`section-${id}`}
				aria-expanded={isActive}
				onClick={onShow}
			>
				<span>{title}</span>
			</button>

			<section
				className="accordion-content"
				id={`section-${id}`}
				aria-labelledby={id}
			>
				{children}
			</section>
		</div>
	);
}

AccordionSingleItem.propTypes = {
	id: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	title: PropTypes.string.isRequired,
	isActive: PropTypes.bool.isRequired,
	onShow: PropTypes.func.isRequired,
};
